export const CANCEL_APPOINTMENT_TITLE =
  'Are you sure you want to cancel this appointment?';
export const CANCEL_APPOINTMENT_TITLE_DESCRIPTION =
  'If you confirm this booking will be permanently canceled and you’ll need to create a new one to restore it.';
export const OTHER_PERSONAL_REASON = 'Other personal reasons';
